import React from 'react';
import { Container, Description, Wrapper } from './EffectChartDropdown.styles';
import { IToggleState, Question } from '../../../../../../../services/reports';
import EffectDropdownTable from '../EffectDropdownTable/EffectDropdownTable';

interface EffectChartDropdownProps {
  questions: Question[];
  togglersState: IToggleState;
  description: string;
}

const EffectChartDropdown: React.FC<EffectChartDropdownProps> = ({
  questions,
  togglersState,
  description,
}) => {
  return (
    <>
      <Wrapper>
        <Container>
          <Description>{description}</Description>
          <EffectDropdownTable questions={questions} togglersState={togglersState} />
        </Container>
      </Wrapper>
    </>
  );
};

export default EffectChartDropdown;
